module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_j_erythristic.601548dd.png";